import React, { useState } from 'react';
export function Footer() {
  const [modalContent, setModalContent] = useState<'privacy' | 'terms' | null>(null);
  return <footer className="bg-[#080808] py-12 px-4 border-t border-border-subtle" data-id="element-323">
      <div className="max-w-content mx-auto text-center" data-id="element-324">
        <div className="mb-8" data-id="element-325">
          <p className="font-serif font-bold text-cream text-sm tracking-widest uppercase" data-id="element-326">
            EL AZÚCAR SILENCIOSO <span className="text-gold mx-2" data-id="element-327">·</span> Por
            Roderic Guillen <span className="text-gold mx-2" data-id="element-328">·</span> GoDeskCore
          </p>
        </div>

        <div className="flex items-center justify-center gap-4 mb-8 font-sans text-[13px] text-gray-warm" data-id="element-329">
          <button onClick={() => setModalContent('privacy')} className="hover:text-gold transition-colors" data-id="element-330">
            Política de Privacidad
          </button>
          <span className="text-border-subtle" data-id="element-331">|</span>
          <button onClick={() => setModalContent('terms')} className="hover:text-gold transition-colors" data-id="element-332">
            Términos de Uso
          </button>
        </div>

        <div className="mb-8 font-sans text-[13px] text-gray-warm" data-id="element-333">
          Contacto:{' '}
          <a href="mailto:soporte@godeskcore.com" className="hover:text-gold transition-colors" data-id="element-334">
            soporte@godeskcore.com
          </a>
        </div>

        <div className="font-sans text-[11px] text-gray-warm/60 leading-relaxed max-w-2xl mx-auto" data-id="element-335">
          <p data-id="element-336">
            © 2025 GoDeskCore. Este producto es informativo y educativo. No
            constituye consejo médico ni reemplaza la orientación de la salud.
            © 2025 GoDeskCore. Todos los derechos reservados.
          </p>
        </div>
      </div>

      {/* Simple Modal */}
      {modalContent && <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setModalContent(null)} data-id="element-337">
          <div className="bg-dark-card border border-border-subtle rounded-lg p-8 max-w-lg w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-338">
            <div className="flex justify-between items-center mb-6" data-id="element-339">
              <h3 className="font-serif text-2xl text-cream" data-id="element-340">
                {modalContent === 'privacy' ? 'Política de Privacidad' : 'Términos de Uso'}
              </h3>
              <button onClick={() => setModalContent(null)} className="text-gray-warm hover:text-cream text-xl" data-id="element-341">
                ✕
              </button>
            </div>
            <div className="font-sans text-gray-warm text-sm space-y-4" data-id="element-342">
              <p data-id="element-343">
                Este es un documento legal de ejemplo para{' '}
                {modalContent === 'privacy' ? 'la Política de Privacidad' : 'los Términos de Uso'}
                .
              </p>
              <p data-id="element-344">
                En un entorno de producción, aquí iría el texto legal completo
                proporcionado por el cliente.
              </p>
            </div>
          </div>
        </div>}
    </footer>;
}